import React from 'react'
const FormContext = React.createContext()

export {
  FormContext
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/formContext.js